import { render, staticRenderFns } from "./ResultadosTab.vue?vue&type=template&id=75815681&scoped=true"
import script from "./ResultadosTab.vue?vue&type=script&lang=js"
export * from "./ResultadosTab.vue?vue&type=script&lang=js"
import style0 from "./ResultadosTab.vue?vue&type=style&index=0&id=75815681&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75815681",
  null
  
)

export default component.exports